import { Grid, makeStyles } from '@material-ui/core'
import IconAndText from 'components/common/IconAndText'
import React from 'react'

const useStyles = makeStyles(theme => ({
  countField: {
    padding: '0 8px',
    fontWeight: 600
  },
  text: {
    color: '#001335',
    fontSize: 13,
    fontWeight: 500
  }
}))

const ScanningScheduleWithCount = ({ containerClassName, scoreOption, onCategoryClicked, selected = false }) => {
  const classes = useStyles({ isTransparent: scoreOption.value === 0, selected })

  const hasAnyValue = !!scoreOption.value && scoreOption.value > 0

  return (
    <Grid
      item
      className={containerClassName}
      style={{
        opacity: !hasAnyValue ? 0.4 : 1,
        backgroundColor: selected ? '#7E8DF3' : !hasAnyValue ? '#F6F6F6' : '#E7EAFF',
        color: selected ? '#FFFFFF' : '#001335',
        pointerEvents: !hasAnyValue ? 'none' : 'auto',
        border: selected ? '2px solid #3C52EF' : 'none'
      }}
      onClick={() => onCategoryClicked(scoreOption.key)}
    >
      <IconAndText
        margin="10px"
        className={classes.text}
        text={scoreOption.label}
        icon={React.createElement(scoreOption.icon, {
          fillColor: scoreOption.fillColor,
          strokeColor: scoreOption.strokeColor,
          size: 'small'
        })}
      />
      <span className={classes.countField}>{scoreOption.value || 0}</span>
    </Grid>
  )
}

export default ScanningScheduleWithCount
